var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[_c('b-table',{attrs:{"items":_vm.units,"fields":[
      // Unit nr. (Unitkenmerk)
      // Adres (Adres)
      // Preventief onderhoud (PreventiefOnderhoud)
      // Correctief onderhoud (CorrectiefOnderhoud)
      // Beheerskosten (Beheerskosten)
      // Spreekluister (Spreekluister)
      // PLOH {Jaar} (PLOH)
      // Correctieve reservering (CorrectieveReservering)
      // GSM Spreekluister (GSM) -- Uit PLOH
      // Begeleiding PLOH (BegeleidingPLOH)
      // Noodvoorziening (Noodvoorziening) -- Uit PLOH
      {
        key: 'UNIT.Kenmerk',
        label: 'Unit nr.',
      },
      {
        key: 'UNIT.Adres',
        label: 'Adres',
        thStyle: { 
          width: '150px' 
        }
      },
      {
        key: 'UNIT.Plaats',
        label: 'Plaats',
      },
      {
        key: 'UNIT.Onderhoud',
        label: 'Onderhoud',
      },
      {
        key: 'PREV.KEO',
        label: 'Prev. onderhoud',
      },
      {
        key: 'PREV.KRN',
        label: 'Keuringen',
      },
      {
        key: 'PREV.BEH',
        label: 'Beheerskosten',
      },
      {
        key: 'PREV.SPL',
        label: 'Spreekluister',
      },
      {
        key: 'PLOH.Total',
        label: 'Totaal PLOH',
      },
      {
        key: 'PLOH.COR',
        label: 'Reservering',
      },
      {
        key: 'PLOH.GSM',
        label: 'GSM Spreekluister',
      },
      {
        key: 'PLOH.BEH',
        label: 'Beg. PLOH',
      },
      {
        key: 'PLOH.NVZ',
        label: 'Noodvoorziening',
      },
    ],"small":"","striped":"","bordered":""},scopedSlots:_vm._u([{key:"cell(UNIT.Kenmerk)",fn:function(data){return [_c('b',[_vm._v(_vm._s(data.value))]),_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.updateUnit(data.item)}}},[_vm._v("\n        Update\n      ")])]}},{key:"cell(UNIT.Adres)",fn:function(data){return [_c('b',[_vm._v(_vm._s(data.value))])]}},{key:"cell(UNIT.Plaats)",fn:function(data){return [_c('b',[_vm._v(_vm._s(data.value))])]}},{key:"cell(UNIT.Onderhoud)",fn:function(data){return [_c('b',[_vm._v(_vm._s(data.value[0]))])]}},{key:"cell(PLOH.COR)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PLOH,"field":"COR"}})]}},{key:"cell(PLOH.Total)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PLOH,"disabled":true,"field":"Total"}})]}},{key:"cell(PLOH.BEH)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PLOH,"field":"BEH"}})]}},{key:"cell(PLOH.NVZ)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PLOH,"disabled":true,"field":"NVZ"}})]}},{key:"cell(PLOH.GSM)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PLOH,"disabled":true,"field":"GSM"}})]}},{key:"cell(PREV.KRN)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PREV,"field":"KRN"}})]}},{key:"cell(PREV.KEO)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PREV,"field":"KEO"}})]}},{key:"cell(PREV.BEH)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PREV,"field":"BEH"}})]}},{key:"cell(PREV.SPL)",fn:function(data){return [_c('FinancieelInput',{attrs:{"value":data.item.PREV,"field":"SPL"}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }